export { TestimonialCard } from './testimonial-card';
export type { TestimonialCardProps } from './testimonial-card';
